var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg18IcCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8,9.7 L9.3,9.7 L9.3,13.2 L12.8,13.2 L12.8,9.7 Z M12.1,2 L12.1,3.4 L6.5,3.4 L6.5,2 L5.1,2 L5.1,3.4 L4.4,3.4 C3.623,3.4 3.007,4.03 3.007,4.8 L3,14.6 C3,15.37 3.623,16 4.4,16 L14.2,16 C14.97,16 15.6,15.37 15.6,14.6 L15.6,4.8 C15.6,4.03 14.97,3.4 14.2,3.4 L13.5,3.4 L13.5,2 L12.1,2 Z M14.2,14.6 L4.4,14.6 L4.4,6.9 L14.2,6.9 L14.2,14.6 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg18IcCalendar);
export default __webpack_public_path__ + "static/media/18_ic_calendar.b079e79b.svg";
export { ForwardRef as ReactComponent };